export default __webpack_public_path__ + "static/media/Capital Heart Zone.8bbdc5b3.jpg";